import { render, staticRenderFns } from "./sharing-add-goods.vue?vue&type=template&id=bc3ec564&scoped=true&"
import script from "./sharing-add-goods.vue?vue&type=script&lang=js&"
export * from "./sharing-add-goods.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc3ec564",
  null
  
)

export default component.exports